<template>
  <div>
    <el-card class="box-card">
      <el-button type="info" @click="clickback">返回</el-button>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Productlist" label="清单" min-width="25%"></el-table-column>
        <el-table-column prop="Statuss" label="状态" min-width="5%"></el-table-column>
        <el-table-column prop="Sendtypes" label="配送方式" min-width="5%"></el-table-column>
        <el-table-column prop="Logisticsname" label="物流公司" min-width="10%"></el-table-column>
        <el-table-column prop="Logisticsid" label="物流单号" min-width="10%"></el-table-column>
        <el-table-column prop="Createusername" label="发货人" min-width="5%"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间" min-width="10%"></el-table-column>
      </el-table>

    </el-card>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      listlog: [],
      orderid: null,
      jigouid: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.orderid = parentdata.params.orderid
      this.jigouid = parentdata.params.jigouid
      this.apiGetNaoxjStockSaleSendlist()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    apiGetNaoxjStockSaleSendlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSaleSendlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
